<template>
    <router-view
        id="main-content"
        class="container-fluid"
    >
    </router-view>
</template>

<script>
export default {};
</script>